import {configureStore} from '@reduxjs/toolkit'

import initMock from '~/mock/mock.dev'
import reducer from '~/reducers'

import api from './middlewares/api'

export const createStore = (state?) => {
  return configureStore({
    reducer,
    preloadedState: state,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api(state, initMock)),
  })
}

export type StoreType = ReturnType<typeof createStore>
export type RootState = ReturnType<StoreType['getState']>
export type AppDispatch = StoreType['dispatch']
